module.exports = {"downloadTerm":"Termos de Uso","downloadGuide":"Manual do Usuário","downloadPrivacy":"Termo de Privacidade","cancelPlan":"Cancelar plano","cancelAccount":"Cancelar conta"}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/CallDownloadTerms/data.json
// module id = 2060
// module chunks = 0